import { Component } from "@kluntje/core";
import { I18nService } from "Services/I18nService";

class FRAFlightsHeadline extends Component {
  constructor() {
    super({
      ui: {
        header: ".fra-flights-headline__content :-one",
      },
      events: [
        {
          event: "FRA_TAB_CHANGE",
          target: "window",
          handler: "handleTabChange",
        },
      ],
    });
  }

  // when translate is not ready choose text value form list
  private headlineList: any = [
    { type: "arrivals", value: "Ankünfte" },
    { type: "departures", value: "Abflüge" },
  ];

  /**
   * Lifecycle hook
   */
  afterComponentRender(): void {
    this.generateHeadline();
  }

  private generateHeadline() {
    if (!document.location.search) return;

    // set default tab state by search params- flight type
    const inputQuery = new URL(document.location.href).searchParams;
    const flighttype = inputQuery.get("flighttype");

    if (!flighttype) return;
    this.setHeadline(flighttype);
  }

  /**
   * update ui on tab change
   *
   * @param {Event} e - change event
   */
  handleTabChange(e: CustomEvent): void {
    e.preventDefault();
    this.setHeadline(e.detail);
  }

  setHeadline(flightType: string) {
    const translateService: I18nService = I18nService.getInstance();
    const labelKey = `fraport.travel.components.content.flight.${flightType}.label`;
    const headerLabel = translateService.loaded
      ? translateService.getKey(labelKey)
      : this.headlineList.find(({ type }: any) => type === flightType).value;

    this.ui.header.innerText = headerLabel;
  }
}

customElements.define("fra-m-flights-headline", FRAFlightsHeadline);

export default FRAFlightsHeadline;
